import React from 'react';
import { Category } from 'module/Model/Categories';
import {
  CategoryLinkWrapper,
  CategoryTextWrapper,
  ClientLinkWrapper,
  ClientTextWrapper
  } from './CategoryLink.s';
import { createPureComponent } from 'module/Common';
import { Localized } from 'module/Model/Localized';
import { LocalizedText, NavProvider } from 'module/View/Common';
import { RouteType } from 'module/Model/Routes';

type Props = {
  categories: Array<Category>;
  prefixSingle?: Localized<string>;
  prefixMutiple?: Localized<string>;
  client?: boolean;
};

export const CategoryLink = createPureComponent<Props>(
  'CategoryLink',
  ({ categories, prefixSingle, prefixMutiple, client = false }) => {
    if (categories.length === 0) {
      return null;
    }
    const LinkWrapper = client ? ClientLinkWrapper : CategoryLinkWrapper;
    const TextWrapper = client ? ClientTextWrapper : CategoryTextWrapper;
    if (categories.length === 1) {
      const category = categories[0];
      if (!category) {
        return null;
      }
      return (
        <TextWrapper>
          <NavProvider
            routeType={RouteType.Category}
            routeId={Category.getId(category)}
            key={Category.getId(category)}
            requestNavigation={true}
          >
            {params => (
              <LinkWrapper {...params.getAnchorProps()}>
                {prefixSingle && <LocalizedText content={prefixSingle} />}
                <LocalizedText content={Category.getName(category)} />
              </LinkWrapper>
            )}
          </NavProvider>
        </TextWrapper>
      );
    }
    return (
      <TextWrapper>
        {prefixMutiple && <LocalizedText content={prefixMutiple} />}
        {categories
          .map(category => (
            <NavProvider
              routeType={RouteType.Category}
              routeId={Category.getId(category)}
              key={Category.getId(category)}
              requestNavigation={true}
            >
              {params => (
                <LinkWrapper {...params.getAnchorProps()}>
                  <LocalizedText content={Category.getName(category)} />
                </LinkWrapper>
              )}
            </NavProvider>
          ))
          .reduce<Array<JSX.Element>>((acc, item, index, arr) => {
            acc.push(item);
            if (index < arr.length - 1) {
              acc.push(<span key={`spit-${index}`}>, </span>);
            }
            return acc;
          }, [])}
      </TextWrapper>
    );
  }
);



// WEBPACK FOOTER //
// ./src/module/View/Publication/PublicationDescription/CategoryLink.tsx